// SavePopup.js
import React from 'react';
import SavepopupIcon from '../../../../animation/jobs/savepopup.svg';
import styles from './SavePopup.module.css';

const SavePopup = ({ onClose }) => {
  return (
     <div className={styles['save-modal-overlay']}>
    <div className={styles['save-popup-wrapper']}>
      <div className={styles['save-container']}>
        <div className={styles['save-content']}>
          <img src={SavepopupIcon} alt="Success" />
          <h2 className={styles['save-title']}>Job saved successfully!</h2>
          <p className={styles['save-message']}>You can track saved jobs in “Saved” tab of My job</p>
          <div className={styles['save-buttons']}>
            <button className={styles['ok-button']} onClick={onClose}>Ok, Got it</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default SavePopup;